import { h, Component, Prop, Element } from '@stencil/core';

@Component({
  shadow: false,
  styleUrls: {
    default: 'igws-logo.less',
    rtl: 'igws-logo.less',
    prime: './prime/igws-logo.less',
    rtl_prime: './prime/igws-logo.less',
    investments: 'igws-logo.less',
    rtl_investments: 'igws-logo.less',
    helpandsupport: 'igws-logo.less',
    rtl_helpandsupport: 'igws-logo.less',
    academy: 'igws-logo.less',
    rtl_academy: 'igws-logo.less',
    landingpages: 'igws-logo.less',
    rtl_landingpages: 'igws-logo.less',
    rebrand: 'igws-logo.less',
    rtl_rebrand: 'igws-logo.less',
    generic: 'igws-logo.less',
    rtl_generic: 'igws-logo.less',
  },
  tag: 'igws-logo',
})
export class LogoComponent {
  @Element() element!: HTMLIgwsLogoElement;
  /**
   * Show link
   */
  @Prop() link!: boolean;
  /**
   * Image to show
   */
  @Prop() image!: string;
  /**
   * Homepage link
   */
  @Prop() homeUrl!: string;
  /**
   * Screen reader
   */
  @Prop() screenReader!: string;

  render() {
    const logoClasses = `logo ${this.image}`;

    if (this.link) {
      return (
        <a class={logoClasses} href={this.homeUrl}>
          <span>{this.screenReader}</span>
        </a>
      );
    } else {
      return <div class={logoClasses} />;
    }
  }
}
